import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { throttle } from 'lodash';
import api from '../../../api/api';
import LoadingIcon from '../../components/loading/loading-icon';
import PostSmItem from './post-sm-item';
import { Context } from '../../../context/global-data-provider';

const PostSmScrollTop = ({ post, manager, pinRef }) => {
  const { postListPart } = useContext(Context);

  const topRef = useRef();
  const aboveRef = useRef(null);
  const [nextPosts, setNextPosts] = useState({ list: [] });
  const [nextHasMore, setNextHasMore] = useState(post.nextHasMore > 0);
  const pageRef = useRef(0);
  const isLoadingRef = useRef(false);
  const hasMoreRef = useRef(post.nextHasMore > 0);

  useEffect(() => {
    const abortController = new AbortController();

    // تابع دریافت پست‌های جدید
    const fetchNextPosts = async () => {
      try {
        if (!topRef.current || isLoadingRef.current || !hasMoreRef.current) {
          return;
        }

        isLoadingRef.current = true;

        const response = await api.getNextPosts(post.category.id, postListPart, post.place, pageRef.current, {
          signal: abortController.signal,
        });

        if (response?.posts) {
          const reversedPosts = response.posts.reverse();

          setNextPosts((prevState) => ({
            ...prevState,
            list: [...reversedPosts, ...prevState.list],
          }));

          setNextHasMore(response.nextHasMore);
          hasMoreRef.current = response.nextHasMore;

          pageRef.current += 1;

          if (manager.topLoadStatus !== 'loaded') {
            manager.setTopLoadStatus('loaded');
          }
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error('Error fetching posts:', error);
        }
      } finally {
        isLoadingRef.current = false;
      }
    };

    // ایجاد تابع throttle شده برای اسکرول
    const handleScroll = throttle(() => {
      if (topRef.current && window.scrollY <= topRef.current.offsetTop && !isLoadingRef.current) {
        fetchNextPosts();
      }
    }, 150);

    window.addEventListener('scroll', handleScroll);

    // اجرای اولیه
    fetchNextPosts();

    return () => {
      abortController.abort();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useLayoutEffect(() => {
    if (pinRef && pinRef.current) {
      pinRef.current();
    }
  }, [nextPosts.list, pinRef]);

  useEffect(() => {
    const node = aboveRef.current;
    if (!node || typeof ResizeObserver === 'undefined' || !pinRef) {
      return undefined;
    }

    const observer = new ResizeObserver(() => {
      pinRef.current();
    });
    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [pinRef]);

  return (
    <div id="post-sm-above" ref={aboveRef}>
      {nextHasMore && (
        <div className="w-100" ref={topRef}>
          {
            /*
                        In the firs load we not have loading icon sho on top.
                         */
            manager.topLoadStatus !== 'initialing' && (
              <LoadingIcon className={'post-loading m-0'} width={32} height={32} fill={'#555555'} key={0} />
            )
          }
        </div>
      )}
      <div className="w-100">
        {nextPosts.list.map((postData) => {
          return <PostSmItem data={postData} key={postData.id} />;
        })}
      </div>
    </div>
  );
};

export default PostSmScrollTop;
